import React from 'react';

const LoadingOverlay = () => (
    <div
        style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            position: 'absolute',
            zIndex: '10',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'white',
        }}
    >
        <h1>Loading...</h1>
    </div>
);

export default LoadingOverlay;
